import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SProductFabrics from "./Fabrics/SProductFabrics";
import SizeSetsLayout from "./Sizes/SizeSetsLayout";
import SProducts from "./SProducts";
import SProductTypes from "./ProductTypes/SProductTypes";
import WoColors from "./WoColors/WoColors";
import WorkflowLayout from "./Workflows/WorkflowLayout";

export default function SProductsLayout() {
  /*   All States
   ********************************************* */
  const [active, setActive] = useState("products");

  const [searchParams, setSearchParams] = useSearchParams();

  /*   All Functions
   ********************************************* */
  const updateSearchParams = (newActive) => {
    // Update the search parameters in the URL with the new active tab
    setSearchParams({ active: newActive });
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    // Check if there is an active tab in the URL search params
    // If so, set the active state to that tab
    // If not, default to "products"
    // This allows the component to reflect the active tab based on the URL
    // This is useful for deep linking or when the user navigates directly to a specific tab
    // This will also update the URL when the active tab changes

    const activeTabParam = searchParams.get("active");
    if (activeTabParam) {
      setActive(activeTabParam);
    } else {
      updateSearchParams("products");
    }
    const activeTab = searchParams.get("active");
    if (activeTab) {
      setActive(activeTab);
    }
  }, [searchParams]);

  return (
    <div style={{ marginLeft: 260, height: "100vh" }}>
      <div className="pt-2 ms-2">
        <div>
          <button
            className={`btn ${
              active === "products" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("products");
            }}
          >
            Products
          </button>
          <button
            className={`btn ${
              active === "productTypes" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("productTypes");
            }}
          >
            Product Types
          </button>
          <button
            className={`btn ${
              active === "fabrics" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("fabrics");
            }}
          >
            Fabrics
          </button>
          <button
            className={`btn ${
              active === "colors" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("colors");
            }}
          >
            Colors
          </button>

          <button
            className={`btn ${active === "sizes" ? "btn-primary" : "bg-white"}`}
            onClick={(e) => {
              updateSearchParams("sizes");
            }}
          >
            {/* All Sizes + Size Sets (user, 2026-10-27). Was "Size Sets";
                "Sizes" since 2026-10-30. */}
            Sizes
          </button>
          <button
            className={`btn ${
              active === "workflow" || active === "stations"
                ? "btn-primary"
                : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("workflow");
            }}
          >
            {/* Workflow per product type, drawn in React Flow (user,
                2026-10-29). Holds Task Stations too since 2026-10-30. */}
            Workflow
          </button>
        </div>
        <div className="p-2">
          {active === "products" && (
            <div>
              <SProducts />
            </div>
          )}
          {active === "productTypes" && (
            <div>
              <SProductTypes />
            </div>
          )}

          {active === "sizes" && (
            <div>
              <SizeSetsLayout />
            </div>
          )}
          {active === "fabrics" && (
            <div>
              <SProductFabrics />
            </div>
          )}
          {active === "colors" && (
            <div>
              <WoColors />
            </div>
          )}
          {(active === "workflow" || active === "stations") && (
            <div>
              <WorkflowLayout
                key={active}
                initialTab={active === "stations" ? "stations" : "workflows"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
